import type { EventBus, SlackMessage } from './EventBus';

export interface CfoSystemOptions {
  bus: EventBus;
  messages: readonly SlackMessage[];
}

export class CfoSystem {
  private readonly dispatched = new Set<string>();

  constructor(private readonly opts: CfoSystemOptions) {}

  tick(fictionalMinutes: number): void {
    for (const m of this.opts.messages) {
      if (this.dispatched.has(m.id)) continue;
      if (fictionalMinutes < m.fictionalMinutes) continue;
      this.dispatched.add(m.id);
      this.opts.bus.emit('slack:message-received', { message: m });
    }
  }
}
